// extracted by mini-css-extract-plugin
export var root = "SwatchList-module--root--8d12e";
export var label = "SwatchList-module--label--b12be";
export var swatchSelection = "SwatchList-module--swatchSelection--a95b1";